import React from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import SpacingModel, { NULL as SpacingModelNULL } from './model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import {
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
} from '@client/components/Editor/settings'

import inlineStyles from './inlineStyles'

/**
 * Block Spacing Component
 *
 * @param {PropTypes} props - React Component propertyies
 * @property {SpacintModel} model - Spacing Model
 */
const Spacing = ({
  model = SpacingModelNULL,
  editor = EditorModelNULL,
  serverRender = false,
}) => {
  const height = model.settings.values.height + 'px'
  const styles = {
    ...inlineStyles.spacing,
    height: height,
    lineHeight: height,
    maxHeight: height,
    fontSize: height,
  }

  if (
    [
      ITEM_TYPE_PAGE,
      ITEM_TYPE_FORM,
      ITEM_TYPE_LANDING_PAGE,
      ITEM_TYPE_LANDING_PAGE_SUCCESS,
      ITEM_TYPE_SURVEY,
      ITEM_TYPE_SURVEY_THANK_YOU,
    ].includes(editor.kind)
  ) {
    return (
      <div className={serverRender ? '' : 'spacing'}>
        <div
          style={styles}
          dangerouslySetInnerHTML={{
            __html: '&nbsp;',
          }}
        />
      </div>
    )
  }

  return (
    <table
      cellSpacing="0"
      cellPadding="0"
      width="100%"
      border="0"
      role="presentation"
      className={serverRender ? '' : 'spacing'}
    >
      <tbody>
        <tr>
          <td
            width="100%"
            height={height}
            style={styles}
            dangerouslySetInnerHTML={{
              __html: '&nbsp;',
            }}
          />
        </tr>
      </tbody>
    </table>
  )
}

Spacing.propTypes = {
  model: PropTypes.instanceOf(SpacingModel),
  editor: PropTypes.instanceOf(EditorModel),
  serverRender: PropTypes.bool,
}

export default inject('serverRender', 'editor')(observer(Spacing))
